import { render, staticRenderFns } from "./SpotlightCallout.vue?vue&type=template&id=eb3f2b58&scoped=true&"
import script from "./SpotlightCallout.vue?vue&type=script&lang=js&"
export * from "./SpotlightCallout.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightCallout.vue?vue&type=style&index=0&id=eb3f2b58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3f2b58",
  null
  
)

export default component.exports